<template>
  <div>
    <div style="margin-top: 20px; font-size: 26px; font-weight: bold">手动上传取件码</div>
    <div style="margin-top: 20px">
      <el-input
        v-model="trackingNo"
        placeholder="同步物流单号"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="pickCode"
        placeholder="取件码"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="address"
        placeholder="代收点"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="expressAddress"
        placeholder="代收点地址"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <el-button v-waves class="filter-item" type="primary" @click="commit">
        提交
      </el-button>
      <br /><br />
      结果：<span>{{ commitResult }}</span>
      <span style="color: red">{{ errorCommitResult }}</span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import waves from "@/directive/waves"; // waves directive

export default {
  name: "pushPickCode",
  directives: { waves },
  data() {
    return {
      trackingNo: "",
      pickCode: "",
      address: "",
      expressAddress: "",
      commitResult: "",
      errorCommitResult: "",
    };
  },
  methods: {
    commit() {
      this.commitResult = "";
      this.errorCommitResult = "";
      const url =
        this.$root.ycApiUrl + "api/express/push-pick-code?trackingNo=" +
        this.trackingNo +
        "&pickCode=" +
        this.pickCode +
        "&address=" +
        this.address +
        "&expressAddress=" +
        this.expressAddress;
      const res = axios.post(url);
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.commitResult = resd.message;
          } else {
            this.errorCommitResult = resd.message;
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          // 处理错误，比如设置data为默认值或错误状态
          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/secondGenerationLogistics/pushPickCode.vue